module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-centered"
  }, [_c('p', [_c('span', [_vm._v("Past 24hr profitability (")]), _c('b', [_vm._v(_vm._s(_vm.selectedAlgorithm.name))]), _c('span', [_vm._v(" mining):")])]), _c('br'), _c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control is-medium is-expanded",
    class: {
      'is-loading': _vm.isLoadingCalculator
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculatorValue),
      expression: "calculatorValue"
    }],
    ref: "calculatorinput",
    staticClass: "input is-medium hr_input",
    attrs: {
      "type": "text",
      "placeholder": _vm.selectedAlgorithm.name,
      "disabled": _vm.isLoadingCalculator
    },
    domProps: {
      "value": (_vm.calculatorValue)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.calculateProfitability.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.calculatorValue = $event.target.value
      }, _vm.debounceInput]
    }
  })]), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitOfMeasurementSelected),
      expression: "unitOfMeasurementSelected"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.unitOfMeasurementSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.calculateProfitability]
    }
  }, _vm._l((_vm.selectOptions), function(o) {
    return _c('option', {
      domProps: {
        "value": o.code
      }
    }, [_vm._v(_vm._s(o.description))])
  }), 0)])])]), _c('br'), _c('table', {
    staticClass: "table-calculate"
  }, [_c('tbody', [_c('tr', [_c('td', [(_vm.calculatorPerDay) ? _c('span', [_vm._v(_vm._s(_vm.calculatorValue) + " " + _vm._s(_vm.unitOfMeasurementSelected.toUpperCase()) + _vm._s(_vm.selectedAlgorithm.minimumUnitOfMeasurement) + "/s")]) : _c('span', [_vm._v("- " + _vm._s(_vm.unitOfMeasurementSelected.toUpperCase()) + _vm._s(_vm.selectedAlgorithm.minimumUnitOfMeasurement) + "/s")])]), _vm._m(0), _c('td', [(_vm.calculatorPerDay) ? _c('span', {
    staticClass: "day_result"
  }, [_vm._v(_vm._s(_vm.calculatorPerDay))]) : _c('span', {
    staticClass: "day_result"
  }, [_vm._v("- ")])]), _c('td', [_vm._v(_vm._s(_vm.coin) + " / day")])]), _c('tr', [_c('td'), _c('td'), _c('td', [(_vm.calculatorPerDay) ? _c('span', {
    staticClass: "month_result"
  }, [_vm._v(_vm._s(_vm.calculatorPerMonth))]) : _c('span', {
    staticClass: "month_result"
  }, [_vm._v("- ")])]), _c('td', [_vm._v(_vm._s(_vm.coin) + " / month")])])])]), _c('br'), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', [_vm._v("=")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fs-12 mw-300 m-auto mt-5 fw-400 has-text-centered"
  }, [_c('span', [_vm._v("Note that results  ")]), _c('a', {
    attrs: {
      "href": "https://unmineable.com/support/article/why-is-there-a-difference-between-my-results-and-the-calculator/"
    }
  }, [_vm._v("may vary")]), _c('span', [_vm._v(". The calculator is based on the pool's past 24hr performance.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44a52e58","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_calculator.vue
// module id = 376
// module chunks = 1